if (!customElements.get("lsg-buybox-rebuild")) customElements.define("lsg-buybox-rebuild", class LSGBuyboxRebuild extends HTMLElement {
    constructor() {
        super();

        this.selectors = {
            buyboxEl: ".lsg-buybox-rebuild",
            stickyBuyboxEl: "lsg-buybox-sticky-atc",
            gallery: ".js-lsg-buybox-rebuild-gallery",
            galleryNav: ".js-lsg-buybox-rebuild-gallery-nav",
            galleryNavPrev: ".js-lsg-buybox-rebuild-gallery-nav-btn-prev",
            galleryNavNext: ".js-lsg-buybox-rebuild-gallery-nav-btn-next",
            galleryNavButton: ".js-lsg-buybox-rebuild-gallery-nav-btn",
            galleryProgressBar: ".js-lsg-buybox-rebuild-gallery-progress-bar",
            gallerySliderProgress: ".js-lsg-buybox-gallery-slide-progress"

        };
        this.buyboxEl = this.querySelector(this.selectors.buyboxEl);
        this.stickyBuyboxEl = document.querySelector(this.selectors.stickyBuyboxEl);

        this.gallery = this.querySelector(this.selectors.gallery);
        this.galleryNav = this.querySelector(this.selectors.galleryNav);
        this.galleryNavNext = this.querySelector(this.selectors.galleryNavNext);
        this.galleryNavPrev = this.querySelector(this.selectors.galleryNavPrev);
        this.galleryNavButton = this.querySelectorAll(this.selectors.galleryNavButton);
        this.galleryProgressBar = this.querySelectorAll(this.selectors.galleryProgressBar);
        this.gallerySliderProgress = this.querySelector(this.selectors.gallerySliderProgress);

        this.formatter = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD"
        });

        if (this.buyboxEl != null) {
            this.init();

            this.initGallery();

            this.debug = false;

            this.rootURL = window.Shopify.routes.root;
        }
    }

    updateProgressBar(progress) {
        progress = Math.max(0, Math.min(1, progress));
        if (this.galleryFlickity != undefined) {
            this.galleryProgressBar.forEach(el => {
                const width = el.parentNode.parentNode.offsetWidth / this.galleryFlickity.cells.length;
                el.style.width = `${width}px`;
                el.parentNode.style.width = `calc( 100% - ${width}px )`;
                el.style.left = `calc( ${progress * 100}% - ${0}px )`;

            });
        }
    }

    updategallerySliderProgress() {
        if (this.galleryFlickity != undefined) {
            let totalSlides = this.galleryFlickity.cells.length;
            let currentIndex = this.galleryFlickity.selectedIndex + 1;

            this.gallerySliderProgress.innerHTML = `<span class="current-slide">${currentIndex}</span><span>/</span><span class="total-slides">${totalSlides}</span>`;
        }
    }

    initGalleryFlickity() {
        if (this.gallery != null) {
            this.galleryNavButton = this.querySelectorAll(this.selectors.galleryNavButton);
            this.galleryNavButton.forEach((el, index) => {
                el.setAttribute('data-index', index);
            });
            this.galleryFlickity = new window.Flickity(this.gallery, {
                pageDots: true,
                prevNextButtons: false,
                cellAlign: (window.innerWidth > 767) ? 'center' : 'left',
                contain: true,
                freeScroll: true,
                on: {
                    change: (index) => {
                        this.galleryNavButton.forEach((el => {
                            el.parentNode.setAttribute('aria-current', parseInt(el.getAttribute('data-index'), 10) == index ? true : false);
                        }));

                        this.galleryNavFlickity.select(index);
                        this.updategallerySliderProgress();

                    },
                    scroll: (progress) => {
                        this.updateProgressBar(progress);
                    }
                }
            });
            this.updategallerySliderProgress();
            this.galleryProgressBar.forEach(el => {
                const width = el.parentNode.parentNode.offsetWidth / this.galleryFlickity.cells.length;
                el.style.width = `${width}px`;
                el.parentNode.style.width = `calc( 100% - ${width}px )`;

            });
            this.galleryNavFlickity = new window.Flickity(this.galleryNav, {
                pageDots: false,
                prevNextButtons: false,
                contain: true,
                cellAlign: 'center',
                groupCells: true,
            });
            window.addEventListener('resize', () => {
                this.galleryFlickity.resize();
                this.galleryFlickity.reposition();
            }, 400);
        }

        window.NSSGalleryUpdate = () => {
            if (this.gallery != null) {
                this.galleryFlickity.destroy();
                window.dispatchEvent(new Event('resize'));
                this.galleryFlickity = new window.Flickity(this.gallery, {
                    pageDots: true,
                    prevNextButtons: false,
                    cellAlign: (window.innerWidth > 767) ? 'center' : 'left',
                    contain: true,
                    freeScroll: false,
                    adaptiveHeight: true,
                    on: {
                        change: (index) => {
                            this.galleryNavButton.forEach((el => {
                                el.parentNode.setAttribute('aria-current', parseInt(el.getAttribute('data-index'), 10) == index ? true : false);
                            }));

                            this.galleryNavFlickity.select(index);

                        },
                        scroll: (progress) => {
                            this.updateProgressBar(progress);
                        }
                    }
                });
                setTimeout(() => {
                    window.dispatchEvent(new Event('resize'));
                }, 400)

            }
        }
    }

    initGallery() {
        if (this.gallery != null) {
            this.initGalleryFlickity();
            this.galleryNavButton.forEach((el => {
                el.addEventListener('click', () => {
                    this.galleryFlickity?.select(parseInt(el.getAttribute('data-index'), 10));
                })
            }));
            this.galleryNavPrev?.addEventListener('click', () => {
                this.galleryFlickity?.previous(true);
            });
            this.galleryNavNext?.addEventListener('click', () => {
                this.galleryFlickity?.next(true);
            });
            window.LSGPDPSliderReinit = () => {
                this.querySelectorAll('.js-lsg-buybox-rebuild-gallery-additional').forEach(el => {
                    el.remove();
                });
                this.galleryFlickity.destroy();
                this.galleryNavFlickity.destroy();

                this.initGalleryFlickity();
            }
        }
    }

    updateBuybox(optionLinkEl) {
        // if (this.debug) console.log(`[NSS] Updating buybox.`);

        optionLinkEl.parentElement.classList.add(`nss-switcher-loading`);

        const pdpURL = this.rootURL + optionLinkEl.getAttribute(`href`).slice(1);
        if (this.debug) console.log(`[NSS] pdpURL:`, pdpURL);

        fetch(pdpURL)
            .then((response) => {
                return response.text()
            })
            .then((html) => {
                const parser = new DOMParser();
                const pdp = parser.parseFromString(html, "text/html");

                // Destroy "sections pro"
                const sectionProEls = new Set([
                    ...document.querySelectorAll(`.sections--pro`),
                    ...pdp.querySelectorAll(`.sections--pro`)
                ]);

                sectionProEls.forEach((sectionProEl) => {
                    sectionProEl.remove();
                });

                // Current PDP
                const nowMain = document.querySelector(`main`),
                    nowSections = Array.from(nowMain.children),
                    nowBuybox = nowSections.shift();

                // New PDP
                const pdpMain = pdp.querySelector(`main`),
                    pdpSections = Array.from(pdpMain.children),
                    pdpBuybox = pdpSections.shift();

                // Naive section count check
                if (pdpSections.length !== nowSections.length) {
                    console.error(`[NSS] Templates must match for in-place loading!`);
                    console.error(`[NSS] Falling back to standard page load.`);
                    window.location = pdpURL;
                }

                // Replace all sub-buybox sections
                nowSections.forEach((nowSection, i) => {
                    nowSection.replaceWith(pdpSections[i]);
                });

                // Re-init Okendo
                const widgetElement = document.querySelector('[data-oke-widget]');
                window.okeWidgetApi.initWidget(widgetElement);

                // Prep gallery elements for color transition
                const productHandle = this.getAttribute(`nss-product-handle`);

                const pdpAccentEls = pdpBuybox.querySelectorAll(`[nss-product-color]`);

                // pdpAccentEls.forEach((pdpAccentEl) => {
                //     pdpAccentEl.classList.add(`nss-product-color-${productHandle}`);
                // });

                // Replace/Update Buybox
                const swapSelectors = [
                    'style[data-shopify]',
                    '.lsg-buybox-rebuild__gallery',
                    '.lsg-buybox-rebuild__info',
                    'lsg-carousel-rebuild',
                    '.lsg-buybox-sticky-atc__wrapper-switcher',
                    '.lsg-buybox-sticky-atc__wrapper-link',
                ];

                swapSelectors.forEach((selector) => {
                    const nowElement = nowBuybox.querySelector(selector),
                        pdpElement = pdpBuybox.querySelector(selector);

                    nowElement.replaceWith(pdpElement);
                });

                // Re-attach cart handler to carousel forms
                const carouselEls = document.querySelectorAll(`nss-carousel`);

                carouselEls.forEach((carouselEl) => {
                    window.NSS_ATTACH_FORMS(carouselEl);
                });

                // Hide debug fields
                const spInputEl = this.querySelector(`[name="selling_plan"]`),
                    productSelectEl = this.querySelector(`[name="id"]`);

                if (!this.debug) {
                    spInputEl.style.display = 'none';
                    productSelectEl.style.display = 'none';
                }

                // Update colors
                // const colorFg       = optionLinkEl.getAttribute(`nss-buybox-option-color-fg`),
                //       colorBg       = optionLinkEl.getAttribute(`nss-buybox-option-color-bg`),
                //       optionHandle  = optionLinkEl.getAttribute(`nss-buybox-option-product-handle`);

                // const accentEls = this.querySelectorAll(`[nss-product-color]`);

                // setTimeout(() => {
                //     accentEls.forEach((accentEl) => {
                //         // accentEl.style.backgroundColor = colorFg;
                //         accentEl.classList.remove(`nss-product-color-${productHandle}`);
                //         accentEl.classList.add(`nss-product-color-${optionHandle}`);
                //     });
                // }, 100);

                // this.setAttribute(`nss-product-handle`, optionHandle);

                /*
                const wiperEl       = this.querySelector(`.nss-section-wipe`),
                      wiperInnerEl  = this.querySelector(`.nss-section-wipe__inner`),
                      wiperWaveEls  = this.querySelectorAll(`.nss-section-wipe__wave path`);

                clearTimeout(this.wipeOut);
                wiperEl.classList.remove(`nss-anim-slide-in`);

                wiperInnerEl.style.backgroundColor = colorBg;
                wiperWaveEls.forEach((wiperWaveEl) => {
                    wiperWaveEl.style.fill = colorBg;
                });

                wiperEl.classList.add(`nss-anim-slide-in`);
                this.wipeOut = setTimeout(() => {
                    wiperEl.classList.remove(`nss-anim-slide-in`);
                    this.style.backgroundColor = colorBg;
                }, 1000);
                */

                // Start videos
                /*
                const autoplayVideoEls = this.querySelectorAll(`video[autoplay]`);

                autoplayVideoEls.forEach((autoplayVideoEl) => {
                    autoplayVideoEl.play();
                });
                */

                // Update reviews
                // const starElement = this.querySelector('[data-oke-star-rating]');
                // window.okeWidgetApi.initWidget(starElement);

                // Update selected option
                /*
                const optionEls = this.querySelectorAll(`.nss-switcher-nav-item`);

                optionEls.forEach((optionEl) => {
                    optionEl.classList.remove(`nss-switcher-nav-item-active`);
                });

                optionLinkEl.parentElement.classList.add(`nss-switcher-nav-item-active`);
                */

                // Refresh upsells
                /*
                const productId = optionLinkEl.getAttribute(`nss-buybox-option-product-id`);

                window.NSS_REFRESH_UPSELLS(productId);
                */

                // Hide loading indicator
                // optionLinkEl.parentElement.classList.remove(`nss-switcher-loading`);

                // Update URL
                window.history.pushState({}, null, pdpURL);

                if (this.debug) console.log(`[NSS] End of buybox update process.`);
            })
            .catch((err) => {
                console.error('Failed to fetch page: ', err);
            });
    }

    updateQuantity(newQty) {
        const quantityEls = document.querySelectorAll(`[name="quantity"]`),
            qtyInputEls = document.querySelectorAll(`[lsg-buybox-qty-input]`);

        if (newQty >= 1 && newQty <= 15) {
            quantityEls.forEach((quantityEl) => {
                quantityEl.setAttribute(`value`, newQty);
            });
            qtyInputEls.forEach((qtyInputEl) => {
                qtyInputEl.setAttribute(`value`, newQty);
            });
        }
    }

    quantityMinus() {
        const quantityEls = document.querySelectorAll(`[name="quantity"]`),
            currentQuantity = parseInt(quantityEls[0].value),
            newQty = currentQuantity - 1;

        this.updateQuantity(newQty);
    }

    quantityPlus() {
        const quantityEls = document.querySelectorAll(`[name="quantity"]`),
            currentQuantity = parseInt(quantityEls[0].value),
            newQty = currentQuantity + 1;

        this.updateQuantity(newQty);
    }

    observed(entries, observer) {
        if (this.debug) console.log(`[NSS] Observed!`);
        const stickyBuyboxEl = document.querySelector(`lsg-buybox-sticky-atc`);

        if (entries[0].isIntersecting) {
            if (this.debug) console.log(`[NSS] Buybox is visible`);
            stickyBuyboxEl.classList.remove(`lsg-buybox-sticky-atc--active`);
        } else {
            if (this.debug) console.log(`[NSS] Buybox is not visible`);
            stickyBuyboxEl.classList.add(`lsg-buybox-sticky-atc--active`);
        }
    }

    init() {
        this.debug = false;
        const buyboxEl = this.buyboxEl;
        const stickyBuyboxEl = this.stickyBuyboxEl;
        const self = this;

        if (this.debug) console.log(`[NSS] Buybox initialized.`);

        // Intersection Observer
        // This did not work with A/B Test 18. It has been reimplemented inside
        // of the test for reliable operation. This needs to be undone once the
        // test is completed, and the winning behavior should be implemented.
        // if (stickyBuyboxEl) {
        //     var options = {
        //         root: document.querySelector('#element'),
        //         rootMargin: '0px',
        //         threshold: 0
        //     }

        //     var observer = new IntersectionObserver(this.observed, options);

        //     if (document.body.classList.contains(`ab-test-18`)) {
        //         const qtyATCEl = buyboxEl.querySelector(`.lsg-buybox-rebuild__qty-atc`);
        //         observer.observe(qtyATCEl);
        //     } else {
        //         const infoEl = buyboxEl.querySelector(`.lsg-buybox-rebuild__info-holder`);
        //         observer.observe(infoEl);
        //     }
        // }


        // Event Delegation
        this.parentElement.addEventListener(`click`, (e) => {
            if (this.debug) console.log(`[NSS] Buybox parent click, e.target:`, e.target);

            if (e.target.hasAttribute(`nss-buybox-load-pdp`)) {
                if (this.debug) console.log(`[NSS] Caught option switcher click.`);
                if (buyboxEl.classList.contains(`js-lsg-load-pdp`)) {
                    e.preventDefault();
                    this.updateBuybox(e.target);
                }
            }

            if (e.target.hasAttribute(`lsg-buybox-qty-minus`)) {
                if (this.debug) console.log(`[NSS] Caught quantity minus click.`);
                this.quantityMinus();
            }

            if (e.target.hasAttribute(`lsg-buybox-qty-plus`)) {
                if (this.debug) console.log(`[NSS] Caught quantity plus click.`);
                this.quantityPlus();
            }
        });

        /* Buybox */
        const sectionId = buyboxEl.getAttribute(`data-section-id`),
            accordionBtnEls = buyboxEl.querySelectorAll(`[lsg-accordion-item]`);

        let productFormEls;

        if (stickyBuyboxEl) {
            productFormEls = new Set([
                ...buyboxEl.querySelectorAll(`[lsg-form-wrapper]`),
                ...stickyBuyboxEl.querySelectorAll(`[lsg-form-wrapper]`)
            ]);
        } else {
            productFormEls = new Set([
                ...buyboxEl.querySelectorAll(`[lsg-form-wrapper]`)
            ]);
        }

        accordionBtnEls.forEach((accordionBtnEl) => {
            accordionBtnEl.addEventListener(`click`, (e) => {
                const parentEl = accordionBtnEl.parentElement;
                if (parentEl.classList.contains(`lsg-accordion-item-open`)) parentEl.classList.remove(`lsg-accordion-item-open`);
                else {
                    accordionBtnEls.forEach((accordionBtnEl) => {
                        const parentEl = accordionBtnEl.parentElement;
                        parentEl.classList.remove(`lsg-accordion-item-open`);
                    });
                    parentEl.classList.add(`lsg-accordion-item-open`);
                }
            });
        });

        productFormEls.forEach((productFormEl) => {
            const productId = productFormEl.getAttribute(`lsg-form-wrapper`),
                productData = JSON.parse(document.getElementById(`ProductJson-${sectionId}-${productId}`).textContent),
                productSelectEl = productFormEl.querySelector(`#productSelect-${productId}`),
                sellingPlanEl = productFormEl.querySelector(`#sellingPlan-${productId}`),
                optionsGroupEls = productFormEl.querySelectorAll(`[lsg-options-group]`),
                addOnRadioEls = buyboxEl.querySelectorAll(`[lsg-add-on-radio]`),
                freqOptionEls = productFormEl.querySelectorAll(`[lsg-freq-variant]`),
                stickyATCEl = productFormEl.querySelector(`.lsg-buybox-rebuild__sticky-atc`),
                addOnSelectEls = buyboxEl.querySelectorAll(`[lsg-add-on-toggle]`);

            // Hide source-of-truth productSelectEl (name='id')
            if (productSelectEl != null) productSelectEl.style.display = `none`;

            // Prepare options' event listeners
            optionsGroupEls.forEach((optionsGroupEl) => {
                const optionGroupEls = optionsGroupEl.querySelectorAll(`[lsg-buybox-option]`);
                optionGroupEls.forEach((optionGroupEl) => {
                    const optionPosition = optionGroupEl.getAttribute(`lsg-option-position`),
                        optionType = optionGroupEl.getAttribute(`lsg-option-type`);
                    switch (optionType) {
                        case "select":
                            const selectEl = optionGroupEl.querySelector(`[name="option-${optionPosition}"]`);
                            selectEl.addEventListener(`change`, (e) => {
                                updateProductSelect(optionGroupEls);
                            });
                            break;
                        case "radio":
                            const radioEls = optionGroupEl.querySelectorAll(`[name="option-${optionPosition}"]`);
                            radioEls.forEach((radioEl) => {
                                radioEl.addEventListener(`change`, (e) => {
                                    updateProductSelect(optionGroupEls);
                                });
                            });
                            break;
                        default:
                            console.log(`TODO: default`);
                    }
                });
            });

            // Add-On Handling
            addOnSelectEls.forEach((addOnSelectEl) => {
                addOnSelectEl.addEventListener(`change`, (e) => {
                    const newValue = addOnSelectEl.value;
                    const targetAddOnRadioEls = buyboxEl.querySelectorAll(`[lsg-add-on-radio][value="${addOnSelectEl.value}"]`);
                    targetAddOnRadioEls.forEach((targetAddOnRadioEl) => {
                        targetAddOnRadioEl.checked = true;
                    });
                    addOnSelectEls.forEach((addOnSelectEl) => {
                        addOnSelectEl.value = newValue;
                    });
                    const addOnPriceDisplay = buyboxEl.querySelector(`[lsg-combo-price-addon]`);
                    if (addOnPriceDisplay) {
                        if (newValue === "none") addOnPriceDisplay.classList.add(`lsg-combo-price__comp`);
                        else addOnPriceDisplay.classList.remove(`lsg-combo-price__comp`);
                    }
                    productSelectEl.dispatchEvent(new Event("change"));
                });
            });

            addOnRadioEls.forEach((addOnRadioEl) => {
                addOnRadioEl.addEventListener(`change`, (e) => {
                    if (addOnRadioEl.value === "none") {
                        const targetAddOnRadioEls = buyboxEl.querySelectorAll(`[lsg-add-on-radio][value="${addOnRadioEl.value}"]`);
                        targetAddOnRadioEls.forEach((targetAddOnRadioEl) => {
                            targetAddOnRadioEl.checked = true;
                        });
                        addOnSelectEls.forEach((addOnSelectEl) => {
                            addOnSelectEl.value = addOnRadioEl.value;
                        });
                        const addOnPriceDisplay = buyboxEl.querySelector(`[lsg-combo-price-addon]`);
                        if (addOnPriceDisplay) addOnPriceDisplay.classList.add(`lsg-combo-price__comp`);
                    } else {
                        const targetAddOnRadioEls = buyboxEl.querySelectorAll(`[lsg-add-on-radio][value="${addOnRadioEl.value}"]`);
                        targetAddOnRadioEls.forEach((targetAddOnRadioEl) => {
                            targetAddOnRadioEl.checked = true;
                        });
                        addOnSelectEls.forEach((addOnSelectEl) => {
                            addOnSelectEl.value = addOnRadioEl.value;
                        });
                        const addOnPriceDisplay = buyboxEl.querySelector(`[lsg-combo-price-addon]`);
                        if (addOnPriceDisplay) addOnPriceDisplay.classList.remove(`lsg-combo-price__comp`);
                    }
                    productSelectEl.dispatchEvent(new Event("change"));
                });
            });

            // CURRENTLY DEFUNCT: Temporary hacky init of pricing
            if (freqOptionEls.length > 0) {
                const initVariantId = freqOptionEls[0].getAttribute(`lsg-freq-variant`),
                    initVariant = productData.variants.find((v) => v.id === parseInt(initVariantId));
                // updateSellingPlanPriceDisplay(initVariant);
            }

            // Frequencies handler
            freqOptionEls.forEach((freqOptionEl) => {
                const radioOTPEl = freqOptionEl.querySelector(`[lsg-radio-otp]`),
                    radioSubEl = freqOptionEl.querySelector(`[lsg-radio-sub]`),
                    freqSelectParentEl = freqOptionEl.querySelector(`.lsg-freq__select`),
                    freqSelectEl = freqOptionEl.querySelector(`[lsg-freq-select]`),
                    variantId = freqOptionEl.getAttribute(`lsg-freq-variant`),
                    variant = productData.variants.find((v) => v.id === parseInt(variantId));
                radioOTPEl.addEventListener(`click`, (e) => {
                    sellingPlanEl.value = "";
                    freqSelectParentEl.classList.remove(`lsg-freq-select-active`);
                    freqOptionEl.setAttribute(`lsg-freq-selection`, `otp`);
                    updatePriceDisplay(variant);
                    updateStickyFreqDisplay("");
                });
                radioSubEl.addEventListener(`click`, (e) => {
                    sellingPlanEl.value = freqSelectEl.value;
                    freqSelectParentEl.classList.add(`lsg-freq-select-active`);
                    freqOptionEl.setAttribute(`lsg-freq-selection`, `sub`);
                    // updateSellingPlanPriceDisplay(variant);
                    updateStickyFreqDisplay(freqSelectEl.value);
                });
                freqSelectEl.addEventListener(`change`, (e) => {
                    sellingPlanEl.value = freqSelectEl.value;
                    updateStickyFreqDisplay(freqSelectEl.value);
                });
                if (stickyATCEl) {
                    const stickyFreqSelectEl = stickyATCEl.querySelector(`[lsg-freq-select]`);
                    if (stickyFreqSelectEl) stickyFreqSelectEl.addEventListener(`change`, (e) => {
                        sellingPlanEl.value = stickyFreqSelectEl.value;
                        if (stickyFreqSelectEl.value === ``) {
                            freqOptionEl.setAttribute(`lsg-freq-selection`, `otp`);
                            radioOTPEl.checked = true;
                        } else {
                            freqOptionEl.setAttribute(`lsg-freq-selection`, `sub`);
                            freqSelectEl.value = stickyFreqSelectEl.value;
                            radioSubEl.checked = true;
                        }
                    });
                }

                function updateStickyFreqDisplay(value) {
                    if (stickyATCEl) {
                        const stickyFreqSelectEl = stickyATCEl.querySelector(`[lsg-freq-select]`);
                        if (stickyFreqSelectEl) stickyFreqSelectEl.value = value;
                    }
                }
            });

            function updateSellingPlanPriceDisplay(variant) {
                const sellingPlanPriceReg = variant.selling_plan_allocations[0].price,
                    sellingPlanPriceComp = variant.selling_plan_allocations[0].compare_at_price;
                priceRegEls.forEach((priceEl) => {
                    priceEl.textContent = self.formatter.format(sellingPlanPriceReg / 100);
                });
                priceCompEls.forEach((priceEl) => {
                    priceEl.textContent = self.formatter.format(sellingPlanPriceComp / 100);
                });
            }

            // Updaters to run when productSelectEl fires 'change' event
            function updatePriceDisplay(variant) {
                const priceRegEls1 = buyboxEl.querySelectorAll(`[lsg-price-regular]`),
                    priceCompEls1 = buyboxEl.querySelectorAll(`[lsg-price-compare]`);
                const addOnRadioEl = productFormEl.querySelector(`[lsg-add-on-price]:checked`);
                let addOnPrice = 0;
                if (addOnRadioEl != null) {
                    if (addOnRadioEl) addOnPrice = parseInt(addOnRadioEl.getAttribute(`lsg-add-on-price`));
                    let sellingPlanReg = 0;
                    let sellingPlanComp = 0;
                    if (sellingPlanEl.value) {
                        sellingPlanReg = getSellingPlanValueReg(variant, sellingPlanEl.value);
                        sellingPlanComp = getSellingPlanValueComp(variant, sellingPlanEl.value);
                    }
                    let prepReg = addOnPrice + sellingPlanReg // + variant.price ;
                    let prepComp = addOnPrice + sellingPlanComp // + variant.compare_at_price  ;
                    priceRegEls1.forEach((priceEl) => {
                        priceEl.textContent = self.formatter.format(prepReg / 100);
                    });
                    if (prepComp > 0) priceCompEls1.forEach((priceEl) => {
                        priceEl.textContent = self.formatter.format(prepComp / 100);
                    });
                } else {
                    const PriceGroup = buyboxEl.querySelectorAll(`[lsg-price-group]`);
                    PriceGroup.forEach(el => {
                        let htmlPrice = `<span class="lsg-price__price" lsg-price-regular="${variant.price}">${self.formatter.format(variant.price / 100)}</span>`
                        // if (variant.compare_at_price) {
                        //     htmlPrice = `<span class="lsg-price__price-compare" lsg-price-compare="${variant.compare_at_price}">${self.formatter.format(variant.compare_at_price / 100)}</span>` + htmlPrice;
                        // }
                        el.innerHTML = htmlPrice;

                    });
                }
            }

            function getSellingPlanValueReg(variant, sellingPlanId) {
                // const sellingPlan = variant.find(s => s.id === parseInt(sellingPlanId));
                // console.log(sellingPlan);
                return variant.selling_plan_allocations[0].price;
            }

            function getSellingPlanValueComp(variant, sellingPlanId) {
                // const sellingPlan = variant.find(s => s.id === parseInt(sellingPlanId));
                // console.log(sellingPlan);
                return variant.selling_plan_allocations[0].compare_at_price;
            }

            function updateOptionDisplay(variant) {
                optionsGroupEls.forEach((optionsGroupEl) => {
                    const optionGroupEls = optionsGroupEl.querySelectorAll(`[lsg-buybox-option]`);
                    optionGroupEls.forEach((optionGroupEl) => {
                        const optionPosition = optionGroupEl.getAttribute(`lsg-option-position`),
                            optionType = optionGroupEl.getAttribute(`lsg-option-type`),
                            optionValue = variant.options[optionPosition];
                        switch (optionType) {
                            case "select":
                                const selectEl = optionGroupEl.querySelector(`[name="option-${optionPosition}"]`);
                                selectEl.value = optionValue;
                                break;
                            case "radio":
                                const radioEl = optionGroupEl.querySelector(`[name="option-${optionPosition}"][value="${optionValue}"]`);
                                radioEl.checked = true;
                                break;
                            default:
                                console.log(`TODO: default`);
                        }
                    });
                });
            }

            function updateFreqDisplay(variant) {
                const freqGroupEls = buyboxEl.querySelectorAll(`[lsg-freq-variant]`),
                    variantFreqGroupEls = buyboxEl.querySelectorAll(`[lsg-freq-variant="${variant.id}"]`);
                freqGroupEls.forEach((freqGroupEl) => {
                    freqGroupEl.classList.remove(`lsg-freq-active`);
                });
                variantFreqGroupEls.forEach((variantFreqGroupEl) => {
                    variantFreqGroupEl.classList.add(`lsg-freq-active`);
                });
                const selectedFreqEl = buyboxEl.querySelectorAll(`[lsg-freq-variant="${variant.id}"]`)[0],
                    freqSelectEl = selectedFreqEl.querySelector(`[lsg-freq-select]`),
                    radioSubEl = selectedFreqEl.querySelector(`[lsg-radio-sub]`);
                if (radioSubEl.checked) {
                    sellingPlanEl.value = freqSelectEl.value;
                    updateSellingPlanPriceDisplay(variant);
                }
            }

            function updateATCDisplay(variant) {
                const atcControlsEls = productFormEl.querySelectorAll(`[lsg-atc-controls]`);
                atcControlsEls.forEach((atcControlsEl) => {
                    if (variant.available) atcControlsEl.removeAttribute(`lsg-atc-controls-sold-out`);
                    else atcControlsEl.setAttribute(`lsg-atc-controls-sold-out`, ``);
                });
            }

            function updateProductSelect(optionGroupEls) {
                const optionsArr = [];
                optionGroupEls.forEach((optionGroupEl) => {
                    const optionPosition = optionGroupEl.getAttribute(`lsg-option-position`),
                        optionType = optionGroupEl.getAttribute(`lsg-option-type`);
                    switch (optionType) {
                        case "select":
                            const selectEl = optionGroupEl.querySelector(`[name="option-${optionPosition}"]`);
                            optionsArr.push([
                                optionPosition,
                                selectEl.value
                            ]);
                            break;
                        case "radio":
                            const radioEl = optionGroupEl.querySelector(`[name="option-${optionPosition}"]:checked`);
                            optionsArr.push([
                                optionPosition,
                                radioEl.value
                            ]);
                            break;
                        default:
                            console.log(`TODO: default`);
                    }
                });
                optionsArr.sort();
                let optionHandle;
                optionsArr.forEach((option) => {
                    const value = option[1].toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
                    if (typeof optionHandle === "undefined") optionHandle = value;
                    else optionHandle += `-${value}`;
                });
                const selectOption = productSelectEl.querySelector(`[lsg-option-handle="${optionHandle}"`);
                productSelectEl.value = selectOption.value;
                productSelectEl.dispatchEvent(new Event("change"));
            }

            // Listen to productSelectEl and perform unifying updates where necessary
            let initialLoad = true;
            productSelectEl.addEventListener(`change`, (e) => {
                const variant = productData.variants.find((v) => v.id === parseInt(e.target.value));
                updateATCDisplay(variant);
                updatePriceDisplay(variant);
                updateOptionDisplay(variant);
                // updateFreqDisplay(variant);
                initialLoad = false;
            });
            // Init
            productSelectEl.dispatchEvent(new Event("change"));
            // Sticky ATC Handler
            if (stickyATCEl) {
                // Sticky ATC Display handler

                /*
                window.addEventListener(`scroll`, (e) => {
                    updateStickyATCDisplay();
                });
                let isShowing = false;

                function updateStickyATCDisplay() {
                    const buyboxFromTop = buyboxEl.getBoundingClientRect().top;
                    const buyboxHeight = buyboxEl.offsetHeight;
                    const delta = buyboxHeight + buyboxFromTop;
                    if (delta < 0 && isShowing === false) {
                        stickyATCEl.setAttribute(`lsg-sticky-atc-show`, true);
                        isShowing = true;
                    } else if (delta > 0 && isShowing === true) {
                        stickyATCEl.setAttribute(`lsg-sticky-atc-show`, false);
                        isShowing = false;
                    }
                }

                updateStickyATCDisplay();
                */
            }
        });
    }
});
